import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import _ from 'lodash'
import PropTypes from 'prop-types'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
const styles = theme => ({
  formControl: {
    // margin : `0 ${theme.spacing.unit}px`
  },
  group: {
    margin: `${theme.spacing.unit}px 0`
  }
})

class CustomerModal extends React.Component {
  static propTypes = {
    customer: PropTypes.object,
    updateCustomer: PropTypes.func,
    createCustomer: PropTypes.func,
    customersNames: PropTypes.array,
    hideModal: PropTypes.func
  }
  static defaultProps = {
    productNames: []
  }
  state = {
    customer: {
      customers_last_name: '',
      customers_first_name: '',
      customers_email: '',
      customers_phone_number: '',
      isMember: false
    },
    isValid: false,
    errors: {},
    helpers: {}
  }
  updateState = nextState => {
    const { customer } = nextState
    const customerProps = this.props.customer
    let isValid = true
    let helpers = {}
    if (
      !customerProps &&
      this.props.customersNames.includes(
        _.lowerCase(
          `${customer.customers_first_name} ${customer.customers_last_name}`
        )
      )
    ) {
      helpers.name = 'Une autre client existe déjà avec ce nom'
    }
    if (customerProps && isValid) {
      isValid = !_.isEqual(customerProps, customer)
    }
    this.setState({ ...nextState, isValid, helpers })
  }
  handleChange = name => (e, val) => {
    const isChecker = e.target.value === 'checker'
    let value = isChecker ? e.target.checked : val || e.target.value
    this.updateState({
      ...this.state,
      customer: { ...this.state.customer, [name]: value }
    })
  }

  handleOnCreate = () => {
    const { customer } = this.state
    this.props.createCustomer(customer)
  }
  handleOnUpdate = () => {
    const { customer } = this.state
    this.props.updateCustomer(this.props.customer, customer)
  }

  componentDidMount() {
    const { customer } = this.props
    let nextState = { ...this.state }
    if (customer) {
      nextState = { customer: { ...customer } }
    }
    this.updateState(nextState)
  }
  render() {
    const { helpers, isValid, customer } = this.state
    const isCreate = !this.props.customer
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        onOk={isCreate ? this.handleOnCreate : this.handleOnUpdate}
        title={
          isCreate
            ? 'Ajouter un client'
            : `Editer ${customer.customers_first_name} ${
                customer.customers_last_name
              }`
        }
        okDisabled={!isValid}>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          justify="space-around">
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="flex-start"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} sm={12} md={10}>
              <TextField
                id="first_name"
                helperText={helpers.name || null}
                required
                label="Prénom"
                onChange={this.handleChange('customers_first_name')}
                value={customer.customers_first_name}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <TextField
                id="last_name"
                helperText={helpers.name || null}
                required
                label="Nom"
                onChange={this.handleChange('customers_last_name')}
                value={customer.customers_last_name}
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            justify="flex-start"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} sm={12} md={10}>
              <TextField
                id="email"
                helperText={helpers.name || null}
                required
                label="Email"
                onChange={this.handleChange('customers_email')}
                value={customer.customers_email}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <TextField
                id="phone"
                helperText={helpers.name || null}
                required
                label="Téléphone"
                onChange={this.handleChange('customers_phone_number')}
                value={customer.customers_phone_number}
                fullWidth
              />
            </Grid>
            <FormControlLabel
              control={
                <Switch
                  checked={customer.isMember}
                  onChange={this.handleChange('isMember')}
                />
              }
              label="Membre"
            />
            {customer.isMember && (
              <TextField
                id="date_exp"
                label="Date d'expiration"
                type="date"
                onChange={this.handleChange('expirationDate')}
                value={moment(customer.expirationDate).format('YYYY-MM-DD')}
                fullWidth
              />
            )}
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(CustomerModal)



// WEBPACK FOOTER //
// ./src/routes/Admin/Customers/components/CustomerModal.js